export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '钱包转账配置';